


























































import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { MaintenanceTaskViewModel } from "./types";
import { AccomodationUnitStatus } from "@/shared/models/accomodationUnitStatus";
import { MaintenanceTeamMember } from "../calendar/CalendarTypes";
import { AccomodationUnitStatusEnum } from "@/shared/models/enums.type";

@Component
export default class MaintenanceGridTile extends Vue {
  @Getter("appParams/unitRenderTypeLineOne") renderTemplateTypeLineOne?: string;
  @Getter("appParams/unitRenderTypeLineTwo") renderTemplateTypeLineTwo?: string;

  @Getter("codebooks/accomodationUnitStatuses")
  accomodationUnitStatuses?: AccomodationUnitStatus[];
  @Getter("maintenance/maintenanceTeam") maintenanceTeam?: MaintenanceTeamMember[];

  @Prop() item?: MaintenanceTaskViewModel;
  accomodationUnitStatusEnum = AccomodationUnitStatusEnum;

  get emphasizedLine() {
    if (
      this.renderTemplateTypeLineOne === "" &&
      this.renderTemplateTypeLineTwo === ""
    ) {
      return this.item?.propertyName ?? "";
    }

    return this.$t(this.renderTemplateTypeLineOne ?? "", this.renderProps);
  }

  get deEmphasizedLine() {
    if (
      this.renderTemplateTypeLineTwo === "" &&
      this.renderTemplateTypeLineOne === ""
    ) {
      return (
        (this.item?.unitTypeName ?? "") +
        (this.item?.unitName ?? "" ? ", " + (this.item?.unitName ?? "") : "")
      );
    }

    return this.$t(this.renderTemplateTypeLineTwo ?? "", this.renderProps);
  }

  get renderProps() {
    return {
      unitName: this.item?.unitName ?? "",
      unitTypeName: this.item?.unitTypeName ?? "",
      propertyName: this.item?.propertyName ?? "",
    };
  }

  get guests() {
    if (!this.item?.numberOfAdults && !this.item?.numberOfChildren) return null;

    return `${this.item.numberOfAdults}${
      this.item.numberOfChildren ? " + " + this.item.numberOfChildren : ""
    }`;
  }

  get statusResourceKey() {
    return (
      this.accomodationUnitStatuses?.find((x) => x.id == this.item?.statusId)
        ?.textResourceKey ?? ""
    );
  }

  get assignedMaintenanceTeamMemberName() {
    return (
      this.maintenanceTeam?.find(
        (x) => x.tenantUserId == this.item?.maintenanceAssignedToTenantUserId
      )?.name ?? ""
    );
  }

  get statusIcon() {
    switch (this.item?.statusId) {
      case AccomodationUnitStatusEnum.NeedsCleaning:
        return "fa-vacuum";
      case AccomodationUnitStatusEnum.NeedsRepair:
        return "fa-tools";
      case AccomodationUnitStatusEnum.CleaningInProgress:
        return "fa-sync";
      case AccomodationUnitStatusEnum.RepairInProgress:
        return "fa-sync";
      default:
        return "fa-map-marker-alt";
    }
  }

  edit() {
    this.$emit("edit", { ...this.item });
  }
}
